// components/Profitability.jsx
export default function Profitability({ company, data }) {
  if (!data) return null;

  const { roa, roe, operatingMargin } = data;

  return (
    <p className="mb-5">
      Profitability and efficiency are analysed using metrics such as Return on Assets (ROA), Return on Equity (ROE), and Operating Margin. {company} reports {roa && <>an ROA of <strong>{roa}%</strong>,</>} {roe && <>an ROE of <strong>{roe}%</strong>,</>} {operatingMargin && <>and an operating margin of <strong>{operatingMargin}%</strong></>} for the current financial year.
    </p>
  );
}
